module.exports = __webpack_public_path__ + "static/media/LocationSVG.c59ab805.svg";